/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createSquare } from '../../factoriesAny.js';
export var squareDependencies = {
  typedDependencies: typedDependencies,
  createSquare: createSquare
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSquare.generated.js
// module id = 1522
// module chunks = 0